import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnlocked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnlocked"><Path d="M4.5 9.5H19.5V21.5H4.5V9.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8 9.25C8 9.52614 8.22386 9.75 8.5 9.75C8.77614 9.75 9 9.52614 9 9.25H8.5H8ZM15.5 6H15V7H15.5H16V6H15.5ZM8.5 9.25H9V6H8.5H8V9.25H8.5ZM12 2.5V3C13.6569 3 15 4.34315 15 6H15.5H16C16 3.79086 14.2091 2 12 2V2.5ZM12 2.5V2C9.79086 2 8 3.79086 8 6H8.5H9C9 4.34315 10.3431 3 12 3V2.5Z" fill="currentColor"/><Path d="M12 14V17" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconUnlocked;
